module.exports = __webpack_public_path__ + "static/media/main.e3a48b6f.png";